// SkyTracker @skytracker/web — WebGL2 capability check (Cesium 1.140+ requires it).
export function hasWebGL2(): boolean {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('webgl2');
    return ctx instanceof WebGL2RenderingContext;
  } catch {
    return false;
  }
}
